import { useEffect } from 'react';

import { Redirect } from 'react-router-dom';
import { message } from 'antd';
import { useLastLocation } from 'react-router-last-location';

import { usePermissions } from 'utils/usePermissions';
import { WORK_ORDER_COLLABORATOR } from 'utils/access-control/roles';

interface IPageNotFoundRedirectProps {
  redirectUrl?: string;
  errorMessage?: string;
}

const PageNotFoundRedirect: React.FunctionComponent<IPageNotFoundRedirectProps> = ({
  redirectUrl,
  errorMessage = 'Sorry, the requested URL does not exist.',
}) => {
  const { HasRole } = usePermissions();
  const isWoCollaborator = HasRole({ role: WORK_ORDER_COLLABORATOR });
  const lastLocation = useLastLocation();
  useEffect(() => {
    message.destroy();
    message.error(
      isWoCollaborator
        ? 'Sorry, the requested URL does not exist or you tried to access a route that is not permitted for your user role.'
        : errorMessage
    );
  }, [errorMessage, isWoCollaborator]);

  return isWoCollaborator ? (
    <Redirect to={redirectUrl || lastLocation || '/work-orders'} />
  ) : (
    <Redirect to={redirectUrl || lastLocation || '/'} />
  );
};

export default PageNotFoundRedirect;
